import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.inicializarAcessibilidade();
    }

    efetuarBaixa(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }

        const {urlAction, dentroDeSubfrm} = event.params || {};

        if (!urlAction) {
            console.error('URL Action não fornecida nos parâmetros da ação.');
            return;
        }

        const isModal = dentroDeSubfrm === true || dentroDeSubfrm === 'true';

        if (isModal && typeof window.carregarConteudoModal === 'function') {
            window.carregarConteudoModal(urlAction, {}, 'modal_acao_capa_processo');
        } else {
            window.location.href = urlAction;
        }
    }

    inicializarAcessibilidade() {
        const modal = this.element.closest('#modal_acao_capa_processo')
            || document.getElementById('modal_acao_capa_processo')
            || this.element;

        if (!modal) {
            return;
        }

        this.anunciarTituloModal(modal);
        this.esconderIcones(modal);
        this.setAriaLiveConteudoDinamico(modal);
    }

    esconderIcones(modal) {
        const icones = modal.querySelectorAll('i.material-icons');
        icones.forEach(function(icone) {
            icone.setAttribute('aria-hidden', 'true');
        });
    }

    anunciarTituloModal(modal) {
        const titulo = modal.querySelector('h1');
        if (!titulo) {
            return;
        }

        titulo.setAttribute('id', 'titulo_modal_acao_capa_processo');
        titulo.setAttribute('tabindex', '0');
        titulo.focus();
    }

    setAriaLiveConteudoDinamico(modal) {
        const conteudoDinamico = modal.querySelector('.modal-content');
        if (!conteudoDinamico) {
            return;
        }
        if (conteudoDinamico.hasAttribute('aria-live')) {
            return;
        }

        conteudoDinamico.setAttribute('aria-live', 'assertive');
    }
}
